import { modal } from "@onhandtech/onhand-fe-shared/lib/components";
import { notificationsSlice } from "@onhandtech/onhand-fe-shared/lib/notifications";
import { combineReducers } from "redux";

import authenticationSlice from "./authentication/authentication.slice";
import campaignsSlice from "./campaigns/campaigns.slice";
import contentSlice from "./content/content.slice";
import countriesSlice from "./countries/countries.slice";
import featuresSlice from "./features/features-slice";
import qrCodeSlice from "./qr-codes/qr-code.slice";
import sectionsSlice from "./sections/sections.slice";
import createOrgSlice from "./create-organisation";
import firebaseSlice from "./firebase";
import {
	createOrganisation,
	createSignupCode,
	deleteCampaign,
	deleteCampaignPermission,
	deleteRequestFilterSets,
	getCampaign,
	getRequestFilterSets,
	getV4TaskTypes,
	patchRequest,
	patchRequestFilterSets,
	postCampaign,
	postCampaignPermission,
	postFile,
	postRequestFilterSets,
	requestFilterDeletePermissions,
	requestFilterSetPermissions,
	requests,
	signUpCodes,
	signUpCodesDetails,
	taskTypes,
	users,
	volunteerGroup,
} from "./redux-modules";
import missionsSlice from "./ayom/missions/missions.slice";

const reduxModules = {
	[signUpCodes.slice.name]: signUpCodes.slice.reducer,
	[signUpCodesDetails.slice.name]: signUpCodesDetails.slice.reducer,
	[createSignupCode.slice.name]: createSignupCode.slice.reducer,
	[volunteerGroup.slice.name]: volunteerGroup.slice.reducer,
	[requests.slice.name]: requests.slice.reducer,
	[patchRequest.slice.name]: patchRequest.slice.reducer,
	[createOrganisation.slice.name]: createOrganisation.slice.reducer,
	[taskTypes.slice.name]: taskTypes.slice.reducer,
	[getV4TaskTypes.slice.name]: getV4TaskTypes.slice.reducer,
	[getRequestFilterSets.slice.name]: getRequestFilterSets.slice.reducer,
	[patchRequestFilterSets.slice.name]: patchRequestFilterSets.slice.reducer,
	[deleteRequestFilterSets.slice.name]: deleteRequestFilterSets.slice.reducer,
	[postRequestFilterSets.slice.name]: postRequestFilterSets.slice.reducer,
	[requestFilterSetPermissions.slice.name]:
		requestFilterSetPermissions.slice.reducer,
	[requestFilterDeletePermissions.slice.name]:
		requestFilterDeletePermissions.slice.reducer,
	[users.slice.name]: users.slice.reducer,
	[postFile.slice.name]: postFile.slice.reducer,
	[getCampaign.slice.name]: getCampaign.slice.reducer,
	[postCampaign.slice.name]: postCampaign.slice.reducer,
	[deleteCampaign.slice.name]: deleteCampaign.slice.reducer,
	[postCampaignPermission.slice.name]: postCampaignPermission.slice.reducer,
	[deleteCampaignPermission.slice.name]: deleteCampaignPermission.slice.reducer,
};

export default combineReducers({
	[firebaseSlice.name]: firebaseSlice.reducer,
	[missionsSlice.name]: missionsSlice.reducer,
	[notificationsSlice.name]: notificationsSlice.reducer,
	[authenticationSlice.name]: authenticationSlice.reducer,
	[countriesSlice.name]: countriesSlice.reducer,
	[qrCodeSlice.name]: qrCodeSlice.reducer,
	[featuresSlice.name]: featuresSlice.reducer,
	[sectionsSlice.name]: sectionsSlice.reducer,
	[createOrgSlice.name]: createOrgSlice.reducer,
	[campaignsSlice.name]: campaignsSlice.reducer,
	[contentSlice.name]: contentSlice.reducer,
	modal: modal.modalSlice.reducer,
	...reduxModules,
});
